// extracted by mini-css-extract-plugin
export default {"container":"add-edit-ngo-modal_container__ZjsxB","formControls":"add-edit-ngo-modal_formControls__G-DiK"};